import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { FaChevronRight } from "react-icons/fa";
import GradientButton from "@/components/ui/GradientButton";
export const hoverCircleClassName = "pointer-events-none absolute -top-[10%] -right-[130px] block h-[200px] w-[200px] rounded-full bg-white/20 transition-[right] duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:-right-[80px]";

/**
 * Become Partner hero — matches live .about-agencys.pad-tb.block-1.dark-bg3.pt170
 */
export default function AboutHero() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="order-1 w-full py-2.5 lg:order-2 lg:w-1/2 lg:self-center lg:px-[15px]"><div className="mb-0 mt-[30px] text-center lg:mt-0"><Image src="/images/images/thedezine-office.jpg" alt="Leading Website and Mobile App Development Company" width={570} height={448} className="mx-auto h-auto w-full rounded-lg object-cover shadow-[rgb(220,220,220)_-20px_20px_35px,rgb(255,255,255)_20px_-40px_35px]" priority={true} /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className="mb-5 font-poppins text-[32px] font-bold leading-[1.2] text-[#050748] sm:text-[40px] lg:text-[56px] dark:text-white">Leading Website and Mobile App Development Company</h1>;
    t2 = <p className="mt-2.5 mb-0 font-open-sans text-[17px] font-normal leading-7 text-[#6a6a8e] dark:text-gray-400">Be a part of The Dezine success story by partnering with us. Our extensive capabilities and cross-industry experience make us an interesting IT software development company in modern times.</p>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="bg-white pt-12 pb-6 transition-colors duration-300 sm:pt-16 sm:pb-[60px] lg:pt-24 xl:pb-[100px] dark:bg-gray-950"><div className="mx-auto w-full max-w-[1200px] px-[15px]"><div className="flex flex-col items-center lg:-mx-[15px] lg:flex-row">{t0}<div className="order-2 mt-3 w-full text-center lg:order-1 lg:mt-0 lg:w-1/2 lg:px-[15px] lg:text-left">{t1}{t2}<GradientButton href="/contact" variant="pink-purple" className="mt-[30px]">Get in touch<FaChevronRight aria-hidden={true} className="text-xs transition-transform duration-300 group-hover:translate-x-1" /></GradientButton></div></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}